export default "__VITE_ASSET__CCr1XwMT__"